module.exports = __webpack_public_path__ + "static/media/SCALE_Screen2.50259bdc.png";